import { ContentfulAnchor } from '@jbhi-fi/apis/src/contentful/types';
import { ScrollTargetProps } from '../../ScrollTarget/ScrollTarget';
import { toUrlSlug } from '@jbhi-fi/utils/src/toUrlSlug/toUrlSlug';
import { ThemeTransformer } from './ThemeTransformer';

export abstract class AnchorTransformer {
  static toScrollTargetProps = (entry: ContentfulAnchor): ScrollTargetProps => {
    return {
      id: toUrlSlug(entry?.fields?.heading ?? ''),
      heading: entry?.fields?.heading,
      showAs: entry?.fields?.showAs,
      theme: entry?.fields?.theme && ThemeTransformer.toContentThemePalette(entry.fields.theme),
    };
  };
}
